module.exports = __webpack_public_path__ + "img/奖章4级@3x.314287c9.png";